export default class Contexts {
  constructor() {
    this.contexts = {};
  }

  get(key) {
    return this.contexts[key];
  }

  add(context) {
    const key = context.key;
    if (!this.contexts[key]) {
      this.contexts[key] = context;
    }
  }

  update(context) {
    const key = context.key;
    if (this.contexts[key]) {
      this.contexts[key].update(context.data);
    } else {
      this.contexts[key] = context;
    }
  }

  replace(context) {
    const key = context.key;
    this.contexts[key] = context;
  }

  remove(key) {
    delete this.contexts[key];
  }

  removeAll() {
    this.contexts = {};
  }

  getAll() {
    return Object.values(this.contexts);
  }

  exportAll() {
    return this.getAll().map(context => context.export());
  }

  getContextsCopy() {
    const copy = new Contexts();
    this.getAll().map(context => copy.add(context));
    return copy;
  }
}
